import SnukTable from './SnukTable';

export default SnukTable;



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/index.js